export default "__VITE_ASSET__76e3a22c__"